import React from 'react'
import cn from 'classnames'
import { Spinner } from '@web/walter-ui-kit'

import styles from './style.module.css'

interface Props {
    type?: 'fullSizeModal' | 'modal' | 'page'
}

function SuspenseLoader({ type = 'fullSizeModal' }: Props) {
    return (
        <div className={cn(styles.wrap, styles[type])}>
            <Spinner size={30} />
        </div>
    )
}

export default SuspenseLoader
